export default "__VITE_ASSET__dVGjw$ZB__"